import LegalPage from "@/components/LegalPage";

const PrivacyPolicy = () => (
  <LegalPage
    seoTitle="Privacy Policy | Evaya Ventures"
    seoDescription="Privacy Policy of Evaya Ventures — how we collect, use and protect information shared with us."
    path="/privacy-policy"
    title="Privacy Policy"
    intro="This Privacy Policy explains how Evaya Ventures collects, uses and protects information shared with us through this website."
    testId="privacy-policy-page"
    sections={[
      {
        heading: "Information We Collect",
        body: [
          "When you submit an enquiry through our contact form, we collect the information you provide: your name, phone number, email address, the nature of your requirement and your message.",
          "We may also collect basic technical information automatically, such as browser type and pages visited, to help us understand how the website is used.",
        ],
      },
      {
        heading: "How We Use Your Information",
        body: [
          "We use the information you provide solely to respond to your enquiry, evaluate opportunities you bring to us and communicate with you about Evaya Ventures' developments and services where relevant.",
          "We do not sell, rent or trade your personal information to third parties.",
        ],
      },
      {
        heading: "Data Retention",
        body: [
          "Enquiry information is retained only for as long as necessary to address your requirement and maintain appropriate business records.",
        ],
      },
      {
        heading: "Your Rights",
        body: [
          "You may request access to, correction of, or deletion of your personal information at any time by contacting us at [official email].",
        ],
      },
      {
        heading: "Changes to This Policy",
        body: [
          "We may update this Privacy Policy from time to time. The latest version will always be available on this page.",
        ],
      },
    ]}
  />
);

export default PrivacyPolicy;
